import React, { useMemo, useState } from "react";
import { Popover } from "@mui/material";
import { Input } from "antd";
import Select from "react-select";

import v2FormSelectStyle from "../../../v2FormSelectStyle";
import v2Styles from "../../../v2Styles.module.css";

export default function ActionRiskValueView({ riskType = "", value = "", initialRiskValue, bgColor = "", label = "", likelihoods = [], consequences = [], riskRatings = [], initialCons, initialLike, onRiskSave, actIndex, actionIndex, isDisabled, ...props }) {

  const [selectedLike, setSelectedLike] = useState(initialLike ? { label: initialLike.name, value: initialLike.id, like_value: initialLike.value } : null);
  const [selectedCons, setSelectedCons] = useState(initialCons ? { label: initialCons.name, value: initialCons.id, cons_value: initialCons.value } : null);

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const riskValue = useMemo(() => {
    let res = "";
    if (selectedLike && selectedLike.like_value && selectedCons && selectedCons.cons_value) {
      const calcValue = selectedLike.like_value * selectedCons.cons_value;
      res = calcValue;
    }
    return res;
  }, [selectedCons, selectedLike]);

  const onSave = () => {
    let riskColor = "";
    if (riskValue && riskRatings) {
      let rating = riskRatings.find(x => x.risk_rating_high_value >= riskValue && x.risk_rating_low_value <= riskValue);
      if (rating) {
        riskColor = rating.risk_colours;
      }
    }
    onRiskSave({ type: riskType, selectedCons: selectedCons, selectedLike: selectedLike, riskValue: riskValue, actionIndex: actionIndex, actIndex: actIndex, riskColor: riskColor })
    onClose();
  }

  const onClick = (e) => {
    if (isDisabled) return;
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  }

  const onClose = () => {
    setAnchorEl(null);
    setSelectedCons(initialCons ? { label: initialCons.name, value: initialCons.id, cons_value: initialCons.value } : null);
    setSelectedLike(initialLike ? { label: initialLike.name, value: initialLike.id, like_value: initialLike.value } : null);
  }

  const content = (
    <div className="py-2" style={{ width: "240px" }} >
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div>
              <div className={v2Styles.Label}>{label}</div>
              <hr style={{ margin: "5px 0px" }} />
              <div>
                <div className={v2Styles.Label}>Likelihood</div>
                <Select
                  options={likelihoods.filter(v => v.active === 1).map(x => ({ label: x.name, value: x.id, like_value: x.value }))}
                  value={selectedLike}
                  menuPortalTarget={document.body}
                  styles={{
                    ...v2FormSelectStyle,
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 1600,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 1600,
                    }),
                  }}
                  menuPosition="fixed"
                  onChange={(v) => setSelectedLike(v)}
                />
              </div>
              <div className="mt-2">
                <div className={v2Styles.Label}>Consequences</div>
                <Select
                  options={consequences.filter(v => v.active === 1).map(x => ({ label: x.name, value: x.id, cons_value: x.value }))}
                  styles={{
                    ...v2FormSelectStyle,
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 1600,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 1600,
                    }),

                  }}
                  value={selectedCons}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  onChange={(v) => setSelectedCons(v)}
                />
              </div>
              <div className="mt-2">
                <div className={v2Styles.Label}>Risk Value</div>
                <Input readOnly className={v2Styles.TextField} value={riskValue ? riskValue : ""} />
              </div>
              <div className="mt-2 d-flex align-items-center justify-content-end" style={{ gap: "5px" }}>
                <button className={`${v2Styles.OutlinedButton} ${v2Styles.SmallButton}`} onClick={(e) => { setAnchorEl(null); }}>Cancel</button>
                <button onClick={() => onSave()} className={`${v2Styles.PrimaryButton} ${v2Styles.SmallButton}`} disabled={!selectedLike || !selectedCons}>Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <td style={{ background: bgColor, cursor: "text" }} {...props} onClick={onClick}>
      <div>{value}</div>
      <div onClick={(e) => e.stopPropagation()}>
        <Popover disableScrollLock id={id}
          open={anchorEl !== null ? true : false} slotProps={{ backdrop: { onClick: (e) => { e.stopPropagation(); onClose(); } }, paper: { sx: { overflow: "visible" } } }} onClose={onClose} anchorEl={anchorEl}>
          {content}
        </Popover>
      </div>
    </td>
  )
}